import DocumentSide from './DocumentSide';
export default DocumentSide;
